import { redirectToLogin } from "./annoucement-sheet";
import { api, language } from "./api";
import authHeader from "./auth-header";
import { PaginationData } from "./employee";
export type DropdownDataWithLanguage = {
  id: number;
  name_en: string;
  name_tc: string;
  name_sc: string;
};
type DepartmentsResponse = {
  module_id: number;
  status: boolean;
  data: DepartmentInfo[];
  total: number;
};

export type TData = {
  data: DepartmentInfo[];
  total: number;
};
export type DepartmentInfo = {
  id?: number;
  name: string;
};
type departmentInput = {
  // sort: string;
  // search: string;
};
export type TaskDepartmentList = {
  departmentList: TaskDepartmentListData[];
};
export type PaginationDepartmentList = {
  departmentList: PaginationDepartmentListData;
};
export type PaginationDepartmentListData = {
  data:TaskDepartmentListData[];
  total: number;
};
export type TaskDepartmentListData = {
  id: number;
  name: string;
};
export type IDepartPaginationData = {
  page: number;
  limit: number | string | undefined;
  search: string | number;
  sort?: string;
};
export const departmentApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDepartmentList: build.query<
    DepartmentsResponse,
    IDepartPaginationData
    >({
      query: ({limit,page,search,sort}) => {
        return ({
          url: `departments?limit=${limit}&page=${page}&search=${search}&sort=${sort}`,
          headers: authHeader(),
        })
      },
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    getDepartmentListWithPagination: build.query<
    PaginationDepartmentList,
    IDepartPaginationData
    >({
      query: ({limit,page,search,sort}) => {
        return ({
          url: `departments?limit=${limit}&page=${page}&search=${search}&sort=${sort}`,
          headers: authHeader(),
        })
      },
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    getDepartmentAllList: build.query<
    TaskDepartmentList,
      void
    >({
      query: () => ({
        url: `getDepartmentList`,
        headers: authHeader(),
      }),
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    getDepartmentsAllListByWorkgroup: build.query<TaskDepartmentList,any>({
      query: ({workgroup_ids}) => {
        return{
          url: `${workgroup_ids && workgroup_ids!=='all'?'getDepartmentList?workgroup_ids='+workgroup_ids:'getDepartmentList'} `,
          headers: authHeader(),
        }},
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    createDepartment: build.mutation<TaskDepartmentList, DropdownDataWithLanguage>({
      query(body) {
        return {
          headers: authHeader(),
          url: `departments`,
          body,
          method: "POST",
        };
      }
    }),
    updateDepartment: build.mutation<TaskDepartmentList, DropdownDataWithLanguage>({
      query(body) {
        return {
          headers: authHeader(),
          url: `departments/${body.id}`,
          body,
          method: "PUT",
        };
      },
      // invalidatesTags: (employees) => {
      //   return [{ type: "Departments", id: "LIST" }];
      // },
    }),
    deleteDepartment: build.mutation<TaskDepartmentList, number>({
      query(id) {
        return {
          headers: authHeader(),
          url: `/departments/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: (employees) => {
        return [{ type: "Departments", id: "LIST" }];
      },
    }),
    deleteSubMenu: build.mutation<any, number>({
      query:(id)=> {
        console.log("id ",id)
        return {
          headers: authHeader(),
          url: `/menus/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: () => [{ type: 'Header' }],
    }),
  }),
});

export const {
  useGetDepartmentListQuery,
  useCreateDepartmentMutation,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation,
  useGetDepartmentAllListQuery,
  useGetDepartmentListWithPaginationQuery,
  useDeleteSubMenuMutation,
  useGetDepartmentsAllListByWorkgroupQuery
} = departmentApi;

export const {
  endpoints: {
    getDepartmentList,
    createDepartment,
    updateDepartment,
    deleteDepartment,
    getDepartmentAllList,
    getDepartmentListWithPagination,
    deleteSubMenu,
    getDepartmentsAllListByWorkgroup
  },
} = departmentApi;
